import { ZIPCODE } from './constants';
import * as dataActions from './data';
import { BASE_URL, ZIPCODE_QUERY_PARAM } from '../constants';
import * as zipcodeActions from '../queryParams';
import content from '../mixins/content';

export function updateZipcode(data) {
  return {
    type: ZIPCODE.UPDATE,
    data,
  };
}

export function updateZipcodeQuery(data) {
  return () => {
    const queryZipcode = zipcodeActions.findParam(ZIPCODE_QUERY_PARAM);
    let url = '';

    if (queryZipcode) {
      url = zipcodeActions.replaceParamOnURL(ZIPCODE_QUERY_PARAM, data.zipcode);
    } else {
      url = zipcodeActions.addParamToURL(ZIPCODE_QUERY_PARAM, data.zipcode);
    }
    history.pushState('', document.title, url);
    zipcodeActions.pushState(url);
  };
}

export function updateOffersAfterZipcodeChange(data) {
  return (dispatch) => {
    const endpoint = content.offersAPIBaseURL;
    let connector = '?';
    if (endpoint.match(/(\?)/)) {
      connector = '&';
    }

    dispatch(updateZipcode(data));

    dispatch(dataActions.loadData(
      `${BASE_URL}${endpoint}${connector}zipCode=${data.zipcode}`,
    ));

    dispatch(updateZipcodeQuery(data));
  };
}

export default updateZipcode;
